export const BOND_CONSTANTS = {
  CUMULATED_VALUE_KEY: 'cumulatedValue'
} as const;

export const TABLE_CONSTANTS = {
  MIN_WIDTH_DESKTOP: 800,
  MIN_WIDTH_MOBILE: 600
} as const; 